import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Auth from '../auth';
import { confirmarMfaApi, loginApi, enlazarMfaUsuarioApi, postSearchUsuario } from '../api/axios'
import { setAuthenticated, setIdSeller, setUserName, setUserCredenciales, setMfaStatus } from '../actions/generalActios'
import { fetchTokenResetPassword, userTypeIds } from '../actions/usuariosActions';
import MiniSpinner from "./General/MiniSpinner";
import { GoogleReCaptcha, withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { toast } from 'react-toastify';
import { encryptPassword } from '../utilities/encryptPassword';

// Wrapper para usar hooks en class component y el Provider de ReCaptcha

class Login extends React.Component {
    constructor(props) {
        super(props);
        //this._SolveReCaptcha = false; //process.env.NODE_ENV === "production"; //desarrollo - no olvidar el appsettings.json que apunta a desarrollo con su score
        this._SolveReCaptcha = true; //produccion - no olvidar el appsettings.json que apunta a produccion con su score
        this.state = {
            user: '',
            email: '',
            password: '',
            errorMessage: '',
            showSpinner: false,
            recoverPassword: false,
            showPassword: false,
            mFaHabilitado: false,
            mfaConfirmado: false,
            showInputMFaHabilitado: false,
            esperandoCodigoDobleAutenticacion: false,
            codigoDobleAutenticacion: "",
            errorCodigoDobleAutenticacion: "",

            // New MFA Flow State
            showMfaPrompt: false,
            showMfaSetup: false,
            codigoQR: null,
            mfaSetupCode: "",
            mfaSetupError: "",
            loginResponseData: null,
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "codigoDobleAutenticacion") {
            const soloNumeros = value.replace(/\D/g, "");
            this.setState({ codigoDobleAutenticacion: soloNumeros });
        } else if (name === "mfaSetupCode") {
            const soloNumeros = value.replace(/\D/g, "");
            this.setState({ mfaSetupCode: soloNumeros });
        } else {
            this.setState({ [name]: value });
        }
    }

    onRequestToken = (event) => {
        event.preventDefault();
        this.setState({ showSpinner: true });

        this.props.fetchTokenResetPassword(this.state.email)
            .then(() => {
                this.setState({ recoverPassword: false });
                toast.success("Se enviará un mail al correo del usuario con un token temporal para que pueda ingresar");
            })
            .catch((err) => {
                const errores = err?.response?.data?.errores || ["No pudo enviarse el token"];
                errores.forEach(error => toast.error(error));
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };


    onLogin = async (e) => {
        e.preventDefault();
        if (this.state.submitted) return;

        this.setState({ submitted: true, showSpinner: true });

        let tokenReCaptcha = "";

        if (this._SolveReCaptcha) {
            if (!this.props.googleReCaptchaProps) {
                this.setState({
                    errorMessage: "El servicio de ReCaptcha no está disponible. Intente nuevamente.",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }

            try {
                tokenReCaptcha = await this.props.googleReCaptchaProps.executeRecaptcha("login");
            } catch (error) {
                console.error("Error executing reCAPTCHA", error);
                this.setState({
                    errorMessage: "Error al validar ReCaptcha. Intente nuevamente.",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }

            if (!tokenReCaptcha) {
                this.setState({
                    errorMessage: "No se pudo obtener el token de ReCaptcha. Intente nuevamente",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }
        }

        const { user, password, codigoDobleAutenticacion } = this.state;

        let requestLogin = {
            Usuario: user,
            Password: encryptPassword(password),
            codigo: codigoDobleAutenticacion,
            idConexion: "string",
            TokenCaptcha: tokenReCaptcha
        }


        let req = loginApi(requestLogin);

        this.props.setUserCredenciales(user, encryptPassword(password))

        req.then(async (res) => {
            const { mfaHabilitado, mfaConfirmado, tipoUsuario, fechaUltimoLogin } = res;

            this.props.setMfaStatus(mfaHabilitado, mfaConfirmado, this.state.codigoDobleAutenticacion);



            // Si es un usuario que debe resetear password (tipo 5)
            if (tipoUsuario == userTypeIds.isResetPassword) {

                this.completeLogin(res);
                return;
            }

            if ((mfaHabilitado === false && mfaConfirmado === false) ||
                (mfaHabilitado === true && mfaConfirmado === false)) {

                // Interceptar inicio de sesión si MFA no está habilitado/confirmado
                this.setState({
                    loginResponseData: res,
                    showMfaPrompt: true,
                    submitted: false,
                    showSpinner: false
                });

            } else if (mfaHabilitado === true && mfaConfirmado === true) {
                this.setState({
                    submitted: false,
                    esperandoCodigoDobleAutenticacion: true,
                    showInputMFaHabilitado: true,
                    showSpinner: false,
                });

                if (this.state.codigoDobleAutenticacion.length === 6) {
                    this.completeLogin(res);
                }
            }


        }).catch(err => {
            let errorMsg = "Error de autenticación";


            if (err?.response?.status === 400 && this.state.esperandoCodigoDobleAutenticacion) {
                errorMsg = "El código de segundo factor de autenticación es inválido";
                this.setState({
                    errorMessage: "",
                    errorCodigoDobleAutenticacion: errorMsg,
                    submitted: false,
                    showSpinner: false,
                    codigoDobleAutenticacion: "",
                });
            } else {
                // Manejo de otros errores
                // Si la API devuelve un array de errores directamente
                if (Array.isArray(err?.response?.data)) {
                    err.response.data.forEach(error => toast.error(error));
                    this.setState({
                        errorMessage: "",
                        submitted: false,
                        showSpinner: false,
                    });
                    return;
                }
                // Errores del backend como array de strings en propiedad 'errores'
                if (err?.response?.data?.errores) {
                    const errores = err.response.data.errores;
                    errores.forEach(error => toast.error(error));
                    this.setState({
                        errorMessage: "",
                        submitted: false,
                        showSpinner: false,
                    });
                    return;
                }

                this.setState({
                    errorMessage: "",
                    submitted: false,
                    showSpinner: false,
                });
            }


        });
    }

    completeLogin = async (res) => {
        const { idSeller, nombre, tipoUsuario, userId, hiddenItemsIds, fechaUltimoLogin, mfaConfirmado, mfaHabilitado } = res;
        let { codProv } = res;

        // Se detecta usuario en proceso de reset si:
        // 1. Es un usuario existente (fechaUltimoLogin).
        // 2. Tiene MFA Confirmado en FALSE.
        // 3. Tiene MFA Habilitado en FALSE (esto lo distingue de usuarios normales pendientes de configurar MFA).
        const isUsuarioExistenteConResetPendiente = mfaHabilitado === false && mfaConfirmado === false && fechaUltimoLogin;

        const isResetPassword = tipoUsuario == userTypeIds.isResetPassword;

        const redirectTo = isResetPassword
            ? `/Usuarios/Editar/${userId}`
            : `/`;

        // Si codProv no vino en el login, lo buscamos en el detalle del usuario
        if (!codProv && tipoUsuario !== userTypeIds.isResetPassword) {
            try {
                // Se busca por nombreUsuario como solicitó el usuario
                const userResponse = await postSearchUsuario({ nombreUsuario: this.state.user });
                if (userResponse.data && userResponse.data.usuario && userResponse.data.usuario.length > 0) {
                    const userObj = userResponse.data.usuario[0];
                    // Intenta con idProveedor (camel) o IdProveedor (pascal)
                    codProv = userObj.idProveedor || userObj.IdProveedor;
                }
            } catch (error) {
                // Silently handle error
            }
        }

        Auth.login(idSeller, nombre, tipoUsuario, userId, hiddenItemsIds, codProv);
        this.setState({ submitted: false, showSpinner: false });

        if (isResetPassword) {
            this.props.navigate(redirectTo, {
                state: {
                    isResetMode: true,
                    resetToken: this.state.password,
                    username: this.state.user || this.state.email // Pass the input user/email
                }
            });
        } else {
            this.props.navigate(redirectTo);
        }
    }

    handleStartMfaSetup = () => {
        this.setState({ showSpinner: true });
        const { userId } = this.state.loginResponseData;
        const { user, password } = this.state;

        let requestEnlazarMfa = {
            idUsuario: userId,
            usuario: user,
            password: encryptPassword(password)
        };

        enlazarMfaUsuarioApi(requestEnlazarMfa)
            .then((res) => {
                this.setState({
                    codigoQR: res.codigoQrEnlace,
                    showMfaSetup: true,
                    showMfaPrompt: false,
                    showSpinner: false
                });
            })
            .catch(err => {
                toast.error("Error al iniciar configuración MFA");
                this.setState({ showSpinner: false });
            });
    }

    handleConfirmMfaSetup = () => {
        const { userId } = this.state.loginResponseData;
        const { mfaSetupCode } = this.state;

        if (!mfaSetupCode || mfaSetupCode.length !== 6) {
            this.setState({ mfaSetupError: "El código debe tener 6 dígitos" });
            return;
        }

        const requestConfirmarMfa = {
            idUsuario: userId,
            codigo: mfaSetupCode,
        };

        this.setState({ showSpinner: true, mfaSetupError: "" });

        confirmarMfaApi(requestConfirmarMfa)
            .then(() => {
                toast.success("MFA configurado correctamente");
                this.props.setMfaStatus(true, true);
                this.completeLogin(this.state.loginResponseData);
            })
            .catch((error) => {
                this.setState({
                    showSpinner: false,
                    mfaSetupError: "Código incorrecto. Intente nuevamente."
                });
            });
    }

    togglePasswordVisibility = () => {
        if (this.state.password.length === 0) {
            toast.warn("Ingrese contraseña");
            return;
        }
        this.setState(prevState => ({ showPassword: !prevState.showPassword }));
    };

    handleVerifyReCaptcha = (token) => {
        if (this.state.setTokenReCaptcha) {
            this.verifyReCaptcha(token);
        }
    }

    render() {
        const { showSpinner, errorMessage, recoverPassword, showInputMFaHabilitado, codigoDobleAutenticacion, showMfaPrompt, showMfaSetup, codigoQR, mfaSetupCode, mfaSetupError } = this.state;

        const IconEye = (isHidden) => (
            <i className={`me-1 mdi mdi-eye${isHidden ? "" : "-off"} mdi-24px text-dark`} />
        );

        // Date Logic
        const currentDate = new Date();
        const mandatoryDate = new Date('2026-02-01');
        const warningEndDate = new Date('2026-02-01');

        const showWarning = currentDate <= warningEndDate;
        const showLaterButton = currentDate < mandatoryDate;

        return (
            <section className="container-fluid login-register bg-light">
                <div className="row justify-content-center">
                    <div className="login-box card col-10 col-sm-8 col-md-6 col-lg-4">
                        <div className="card-body">
                            <form className="form-horizontal form-material" id="loginform" action="index.html">

                                <div className="d-flex justify-content-center">
                                    <img className="w-75 m-b-40" src="/img/logo-marketplace-megatone.png" />
                                </div>

                                {!recoverPassword ?
                                    <div>
                                        {/* MFA Prompt UI */}
                                        {showMfaPrompt ? (
                                            <div className="text-center">
                                                <h4 className="mb-3">Configuración de Doble Factor</h4>
                                                <p>Para mejorar la seguridad de tu cuenta, te recomendamos activar el doble factor de autenticación.</p>
                                                <p className="text-danger fw-bold">A partir del 01/02/2026 será obligatorio.</p>

                                                <button
                                                    type="button"
                                                    className="btn btn-block background-rojo-megatone w-100 mb-2"
                                                    onClick={this.handleStartMfaSetup}
                                                >
                                                    Configurar ahora
                                                </button>

                                                <a
                                                    href="/manual_mfa.html"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-outline-secondary w-100 mb-2"
                                                >
                                                    <i className="mdi mdi-help-circle-outline me-1"></i>
                                                    Ayuda para configurar
                                                </a>

                                                {showLaterButton && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-link w-100"
                                                        onClick={() => this.completeLogin(this.state.loginResponseData)}
                                                    >
                                                        Más tarde
                                                    </button>
                                                )}
                                            </div>
                                        ) : showMfaSetup ? (
                                            <div className="text-center">
                                                <h5 className="mb-3">Escaneá el código QR</h5>
                                                {codigoQR && (
                                                    <img
                                                        src={`data:image/png;base64,${codigoQR}`}
                                                        alt="QR de autenticación"
                                                        style={{ width: 200, height: 200 }}
                                                        className="mb-3"
                                                    />
                                                )}
                                                <p className="small text-muted">
                                                    Usá una app como Microsoft Authenticator o Google Authenticator.
                                                </p>

                                                <input
                                                    required
                                                    name="mfaSetupCode"
                                                    type="text"
                                                    className="form-control mb-3 text-center"
                                                    placeholder="Ingresá el código de 6 dígitos"
                                                    onChange={this.handleChange}
                                                    maxLength={6}
                                                    value={mfaSetupCode}
                                                />
                                                {mfaSetupError && <small className="text-danger d-block mb-2">{mfaSetupError}</small>}

                                                <button
                                                    type="button"
                                                    className="btn btn-block background-rojo-megatone w-100"
                                                    onClick={this.handleConfirmMfaSetup}
                                                >
                                                    Confirmar
                                                </button>

                                                {showLaterButton && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-link w-100 mt-2"
                                                        onClick={() => this.setState({ showMfaSetup: false, showMfaPrompt: true })}
                                                    >
                                                        Cancelar
                                                    </button>
                                                )}
                                            </div>
                                        ) : (
                                            // Normal Login UI
                                            <>
                                                <div className="form-group">
                                                    <div className="col-12">
                                                        <input
                                                            required
                                                            name="user"
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Usuario..."
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <div className="input-group">
                                                        <div className="col-12">
                                                        </div>
                                                        <input
                                                            required
                                                            name="password"
                                                            type={this.state.showPassword ? "text" : "password"}
                                                            className="form-control"
                                                            placeholder="Contraseña"
                                                            onChange={this.handleChange}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-link"
                                                            onClick={this.togglePasswordVisibility}
                                                        >
                                                            {IconEye(this.state.showPassword)}
                                                        </button>
                                                    </div>
                                                </div>

                                                {showInputMFaHabilitado && (
                                                    <div className="form-group">
                                                        <div className="col-12">
                                                            <input
                                                                required
                                                                name="codigoDobleAutenticacion"
                                                                type="text"
                                                                className={`form-control ${this.state.errorCodigoMfa ? "is-invalid" : ""}`}
                                                                placeholder="Ingresá el código de 6 dígitos"
                                                                onChange={this.handleChange}
                                                                maxLength={6}
                                                                value={codigoDobleAutenticacion}
                                                            />
                                                            {this.state.errorCodigoDobleAutenticacion && (
                                                                <small className="text-danger">{this.state.errorCodigoDobleAutenticacion}</small>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="row align-items-center justify-content-center">
                                                    <div className="col-10">
                                                        <span className="color-rojo-megatone p-2 text-center">
                                                            {errorMessage}
                                                        </span>
                                                    </div>
                                                </div>

                                                {this._SolveReCaptcha &&
                                                    <GoogleReCaptcha
                                                        onVerify={this.handleVerifyReCaptcha}
                                                    />
                                                }

                                                <div className="form-group text-center">
                                                    {(showSpinner) ? <MiniSpinner /> :
                                                        <div>
                                                            <div className="d-block mt-3">
                                                                <button
                                                                    onClick={this.onLogin}
                                                                    className="btn btn-block background-rojo-megatone w-75"
                                                                    type="submit"
                                                                >
                                                                    Entrar
                                                                </button>
                                                            </div>

                                                            <div className="d-block mt-2">
                                                                <button
                                                                    onClick={() => this.setState({ recoverPassword: true })}
                                                                    className="btn btn-link w-75"
                                                                    type="submit" // Cambiado a submit para evitar el comportamiento predeterminado si es necesario, pero es un botón
                                                                >
                                                                    Recuperar contraseña
                                                                </button>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                                {/* Warning Message */}
                                                {showWarning && (
                                                    <div className="alert alert-warning mt-3 text-center" role="alert">
                                                        <i className="mdi mdi-alert me-1"></i>
                                                        A partir del 01/02/2026 el doble factor será obligatorio
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    :

                                    <div>
                                        <div className="form-group">
                                            <div className="col-12">
                                                <a>Email del usuario</a>
                                                <input
                                                    required
                                                    name="email"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Email del usuario"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group p-1 text-center">
                                            <div className="col-12">
                                                {showSpinner ? (
                                                    <MiniSpinner />
                                                ) : (
                                                    <button
                                                        onClick={this.onRequestToken}
                                                        className="btn btn-block btn-large background-rojo-megatone rounded-sm"
                                                        type="submit"
                                                    >
                                                        Solicitar nueva contraseña
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// Wrapper para usar hooks en class component y el Provider de ReCaptcha
const LoginWithRecaptcha = withGoogleReCaptcha(Login);

const LoginWrapper = (props) => {
    const navigate = useNavigate();
    return <LoginWithRecaptcha {...props} navigate={navigate} />;
};

const mapStateToProps = state => ({
    userType: state.general.userType,
    userId: state.general.userId
});

export default connect(mapStateToProps, {
    fetchTokenResetPassword,
    setAuthenticated,
    setIdSeller,
    setUserName,
    setUserCredenciales,
    setMfaStatus,
})(LoginWrapper);
